import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class AssignConfig extends BasicConfig {
  privileges: {
    assigned: { // TODO(MOJAT-3794): may need to be renamed to shortlist
      candidates: string;
      jobs: string;
    };
    hiringManager: string;
  };
}

export type AssignPrivileges = AssignConfig['privileges'];
